import React from 'react';

interface Props {
  title: string;
  icon: React.ReactNode;
  description?: string;
  children: React.ReactNode;
  delayMs?: number;
  className?: string;
}

export default function SectionCard({
  title,
  icon,
  description,
  children,
  delayMs = 0,
  className = '',
}: Props): React.ReactElement {
  return (
    <div
      className={`ss-fade-up bg-[#14142a] border border-gray-800/80 rounded-2xl p-5 shadow-xl shadow-black/20 transition-colors hover:border-violet-800/50 ${className}`}
      style={{ animationDelay: `${delayMs}ms` }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-violet-600/15 border border-violet-700/30 flex items-center justify-center text-violet-300">
            {icon}
          </div>
          <div>
            <h2 className="text-base font-bold text-white">{title}</h2>
            {description && <p className="text-xs text-gray-500 mt-0.5">{description}</p>}
          </div>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}
